import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
export var useHintStore = defineStore({
  id: 'hint',
  state: function state() {
    return {
      hint: null,
      clone: null,
      placement: null,
      fallbackPlacements: null,
      ddName: 'hint-dd',
      hydrated: false,
      closedHints: []
    };
  },
  actions: {
    open: function open(_ref) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var clone, hint, placement, fallbackPlacements;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              clone = _ref.clone, hint = _ref.hint, placement = _ref.placement, fallbackPlacements = _ref.fallbackPlacements;
              if (!_this.$nuxt.$modalityStore.dropdowns.some(function (o) {
                return o.name == _this.ddName;
              })) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _this.$nuxt.$modalityStore.closeDropdowns({});
              _this.clone = clone;
              _this.hint = hint;
              _this.placement = placement;
              _this.fallbackPlacements = fallbackPlacements || null;

              // Let component update hint value
              setTimeout(function () {
                _this.$nuxt.$modalityStore.openDropdown({
                  name: _this.ddName
                });
              }, 10);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    close: function close(hint) {
      var _this2 = this;
      this.$nuxt.$modalityStore.closeDropdown({
        name: this.ddName
      });
      var index = this.closedHints.indexOf(hint);
      if (index < 0) this.closedHints.push(hint);
      this.$nuxt.$axios.$get('/userhints/update', {
        params: {
          hint: hint
        },
        progress: false
      }).then(function (res) {
        _this2.closedHints = res.closedHints;
      }).catch(function (err) {
        return console.log(err);
      });

      // wait for dropdown animation
      if (this.clone) {
        setTimeout(function () {
          _this2.clone.hintDone();
          _this2.clone = null;
          _this2.hint = null;
          _this2.placement = null;
        }, 350);
      }
    },
    restore: function restore(hint) {
      var _this3 = this;
      var index = this.closedHints.indexOf(hint);
      if (index < 0) this.closedHints.splice(index, 1);
      this.$nuxt.$axios.$get('/userhints/restore', {
        params: {
          hint: hint
        },
        progress: false
      }).then(function (res) {
        _this3.closedHints = res.closedHints;
      }).catch(function (err) {
        return console.log(err);
      });
    },
    hydrate: function hydrate() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.$nuxt.$axios.$get('/userhints/find', {
                progress: false
              }).catch(function (err) {
                return console.log(err);
              });
            case 2:
              res = _context2.sent;
              if (res) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              _this4.closedHints = res.closedHints;
              _this4.hydrated = true;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
});